// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ScreensNames } from '@front/controls/UtilsClasses/FactoryConstants';
import { TerceraRecoverScreen } from '@front/controls/screen/TerceraRecoverScreen';
import InvestingForgotPasswordScreenTemplate from '../TradingPlatformTemplates/InvestingForgotPasswordScreenTemplate.html';
import { Resources } from '@shared/localizations/Resources';
import { ChangePasswordStatusEnum } from '@shared/utils/Enums/ChangePasswordStatusEnum';
export class InvestingForgotPasswordScreen extends TerceraRecoverScreen {
    constructor() {
        super();
    }
    oninit() {
        super.oninit();
        this.observe('visible', (v) => {
            if (v)
                this.set('currentStep', TerceraRecoverScreen.CredentialStep);
        });
    }
    getType() {
        return ScreensNames.InvestingForgotPasswordScreen;
    }
    close() {
        this.clearAllAndHide();
    }
    SendMessageFinish(result) {
        super.SendMessageFinish(result);
        const currentStep = this.get('currentStep');
        if (result.status === ChangePasswordStatusEnum.STATUS_ACCEPTED &&
            currentStep === TerceraRecoverScreen.VerificationCodeStep) {
            const msgText = Resources.getResource('screen.RecoveryPassForm.RequestSentToEmailSuccessfully');
            this.showMSG(msgText);
        }
    }
    closeScreenEventClick() {
        super.clearAllAndHide();
    }
}
TerceraRecoverScreen.extendWith(InvestingForgotPasswordScreen, {
    template: InvestingForgotPasswordScreenTemplate,
    data: () => ({ visible: false })
});
